"use client";

import { Button } from "@/components/ui/button";
import { Filter } from "lucide-react";

interface FilterToggleProps {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  icon?: boolean;
}

export default function FilterToggle({ label, isActive = false, onClick, icon = false }: FilterToggleProps) {
  return (
    <Button 
      variant={isActive ? "default" : "outline"} 
      className="flex items-center gap-2"
      onClick={onClick}
    >
      {icon && <Filter size={16} />}
      {label}
    </Button>
  );
} 